<template lang="pug">
  .component-reject-driver-request-buttons
    .dropdown-buttons
      ActionButton(:action="start", confirm) Start
      ActionButton(:action="end", confirm) End
</template>

<script>
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from "../../../../maggieHelper";
import ActionButton from "../ActionButton.vue";
import {EventBus} from "src/eventBus";

export default {
  name: "ChargingSessionButtons",
  components: {ActionButton},
  methods: {
    start() {
      return KeplerBackofficeSdk.chargingSessions.select(this.item).start(() => {
        EventBus.$emit('reload-list')
        MaggieHelper.notification('Charging session', 'started successfully')
      })
    },
    end() {
      return KeplerBackofficeSdk.chargingSessions.select(this.item).end(() => {
        EventBus.$emit('reload-list')
        MaggieHelper.notification('Charging session', 'ended successfully')
      })
    }
  },
  props: ["item"]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ChargingSessionButtons.vue?79b60268